// Lazy reader for the merchant-/embed-emitted customer config.
//
// The app-embed block (and the manual Liquid snippet on /settings/embed)
// set window.QuoteBuilderConfig.customer for logged-in customers. The
// bundle used to capture window.QuoteBuilderConfig ONCE at module
// load (`merchantConfig`), which silently dropped the customer when a
// manual install placed the config snippet AFTER the embed script
// tag. detectShopifyCustomer now reads through this helper at
// DETECT-time, so any tag order works — the only requirement is that
// the config exists by the time the form boots.
export function readConfiguredCustomer(win: unknown): any | null {
  const cfg = (win && (win as any).QuoteBuilderConfig) || {};
  return cfg.customer || null;
}
